import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
const KEY = "reading_nest_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (pkg) => {
    setItems((prev) => (prev.find((p) => p.id === pkg.id) ? prev : [...prev, pkg]));
  };
  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const clearCart = () => setItems([]);
  const inCart = (id) => items.some((p) => p.id === id);
  const total = items.reduce((s, p) => s + Number(p.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, inCart, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
